.header {
  position: sticky;
  top: 0;
  z-index: 60;
  background: rgba(255, 255, 255, 0.88);
  backdrop-filter: blur(18px);
  border-bottom: 1px solid var(--surface-container-high, #dce9ff);
  box-shadow: 0 1px 3px rgba(30, 58, 138, 0.04);
}

.container {
  max-width: 1480px;
  margin: 0 auto;
  padding: 0.75rem 1.5rem;
}

.topRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
}

.brandGroup {
  display: flex;
  align-items: center;
  gap: 0.85rem;
  min-width: 0;
}

.logoMark {
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  border-radius: 12px;
  background: linear-gradient(135deg, #00236f 0%, #1e3a8a 60%, #006a61 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: var(--font-display);
  font-weight: 800;
  font-size: 1.02rem;
  color: #ffffff;
  box-shadow: 0 4px 12px rgba(0, 35, 111, 0.22);
}

.brandTitle {
  font-family: var(--font-display);
  font-size: 1.15rem;
  font-weight: 800;
  letter-spacing: -0.02em;
  color: var(--primary, #00236f);
  display: flex;
  align-items: center;
  gap: 0.55rem;
  flex-wrap: wrap;
  line-height: 1.15;
}

.versionTag {
  font-family: var(--font-sans);
  font-size: 0.66rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  padding: 0.16rem 0.52rem;
  border-radius: 999px;
  background: rgba(134, 242, 228, 0.45);
  color: var(--secondary, #006a61);
  border: 1px solid rgba(0, 106, 97, 0.2);
}

.brandSubtitle {
  font-size: 0.76rem;
  font-weight: 500;
  color: var(--on-surface-variant, #444651);
  margin: 0.14rem 0 0 0;
}

.userMenuWrapper {
  position: relative;
  margin-left: auto;
  flex-shrink: 0;
}

.userTriggerButton {
  display: inline-flex;
  align-items: center;
  gap: 0.55rem;
  background: var(--surface-container-low, #eff4ff);
  border: 1px solid var(--surface-container-highest, #d5e3fc);
  border-radius: 999px;
  padding: 0.42rem 0.9rem;
  font-size: 0.82rem;
  font-weight: 600;
  color: var(--on-surface, #0d1c2e);
  cursor: pointer;
  transition: all 0.16s ease;
}

.userTriggerButton:hover,
.userTriggerButtonOpen {
  background: var(--surface-container, #e6eeff);
  border-color: var(--primary, #00236f);
  color: var(--primary, #00236f);
  box-shadow: 0 0 0 3px rgba(0, 35, 111, 0.08);
}

.userAvatarIcon {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: var(--primary-fixed, #dce1ff);
  border: 1px solid rgba(0, 35, 111, 0.25);
  color: var(--primary, #00236f);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
}

.userTriggerEmail {
  max-width: 220px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.userTriggerChevron {
  font-size: 0.72rem;
  color: var(--on-surface-variant, #444651);
}

.userPopover {
  position: absolute;
  top: calc(100% + 0.6rem);
  right: 0;
  width: 345px;
  background: var(--surface-container-lowest, #ffffff);
  border: 1px solid var(--surface-container-highest, #d5e3fc);
  border-radius: 18px;
  box-shadow: var(--shadow-modal);
  padding: 1.1rem;
  display: flex;
  flex-direction: column;
  gap: 0.9rem;
  z-index: 100;
}

.popoverHeader {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  padding-bottom: 0.8rem;
  border-bottom: 1px solid var(--surface-container-high, #dce9ff);
}

.popoverAvatarLarge {
  width: 42px;
  height: 42px;
  flex-shrink: 0;
  border-radius: 50%;
  background: linear-gradient(135deg, #00236f 0%, #006a61 100%);
  color: #ffffff;
  font-family: var(--font-display);
  font-weight: 800;
  font-size: 1.02rem;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 10px rgba(0, 35, 111, 0.18);
}

.popoverIdentity {
  flex: 1;
  min-width: 0;
}

.popoverUserName {
  margin: 0;
  font-family: var(--font-display);
  font-size: 0.94rem;
  font-weight: 700;
  color: var(--on-surface, #0d1c2e);
}

.popoverUserEmail {
  margin: 0.15rem 0 0 0;
  font-size: 0.78rem;
  color: var(--on-surface-variant, #444651);
  font-family: var(--font-mono);
  word-break: break-all;
}

.popoverUserMeta {
  margin: 0.22rem 0 0 0;
  font-size: 0.73rem;
  color: var(--outline, #757682);
}

.popoverCloseBtn {
  background: var(--surface-container-low, #eff4ff);
  border: 1px solid var(--surface-container-high, #dce9ff);
  color: var(--on-surface-variant, #444651);
  font-size: 1.1rem;
  line-height: 1;
  cursor: pointer;
  padding: 0.2rem 0.45rem;
  border-radius: 8px;
}

.popoverCloseBtn:hover {
  background: var(--surface-container, #e6eeff);
  color: var(--primary, #00236f);
}

.renewalSection {
  background: var(--surface-container-low, #eff4ff);
  border: 1px solid var(--surface-container-high, #dce9ff);
  border-radius: 12px;
  padding: 0.85rem 0.95rem;
  display: flex;
  flex-direction: column;
  gap: 0.52rem;
}

.renewalSectionTitle {
  font-size: 0.74rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--primary, #00236f);
  margin-bottom: 0.15rem;
}

.renewalInfoRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  font-size: 0.78rem;
}

.renewalLabel {
  color: var(--on-surface-variant, #444651);
}

.renewalValueHighlight {
  font-family: var(--font-mono);
  font-weight: 700;
  color: var(--primary, #00236f);
  text-align: right;
}

.renewalValueMono {
  font-family: var(--font-mono);
  font-weight: 600;
  color: var(--on-surface, #0d1c2e);
  text-align: right;
}

.renewalValueEmerald {
  font-family: var(--font-mono);
  font-weight: 700;
  color: var(--secondary, #006a61);
  text-align: right;
}

.popoverFooter {
  padding-top: 0.2rem;
}

.logoutPopoverButton {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.45rem;
  padding: 0.65rem 0.9rem;
  border-radius: 10px;
  background: var(--error-container, #ffdad6);
  border: 1px solid rgba(186, 26, 26, 0.25);
  color: var(--on-error-container, #93000a);
  font-size: 0.83rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.15s ease;
}

.logoutPopoverButton:hover {
  background: #ffc9c2;
  color: #690005;
}

@media (max-width: 900px) {
  .container {
    padding: 0.68rem 1rem;
  }

  .brandSubtitle {
    display: none;
  }

  .userTriggerButton {
    width: 40px;
    height: 40px;
    padding: 0;
    border-radius: 50%;
    justify-content: center;
  }

  .userAvatarIcon {
    width: 30px;
    height: 30px;
    font-size: 0.9rem;
  }

  .userTriggerEmail,
  .userTriggerChevron {
    display: none;
  }

  .userPopover {
    width: min(330px, calc(100vw - 2rem));
    right: 0;
  }
}
